<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: Secondary
 * FIGMA: https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=212-73560&m=dev
 */
// types
import type { BtnSecondaryProps } from '../types/interfaces'
// hooks
import { useBtnSecondary } from '../composables/use-btn-secondary.hook'

defineOptions({
  name: 'BtnSecondary',
})

const props = withDefaults(defineProps<BtnSecondaryProps>(), {
  disabled: false,
  color: 'blue',
  size: 'medium',
  elementWidth: 'auto',
  selected: false,
})

const emit = defineEmits<{
  click: []
}>()

const {
  classList,
  handleClick,
} = useBtnSecondary({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <button
    type="button"
    :class="classList"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot name="iconLeft" />
    <span
      v-if="$slots.default"
      class="ui-btn-secondary__text"
    >
      <slot />
    </span>
    <slot name="iconRight" />
  </button>
</template>

<style lang="scss" scoped src="../styles/_btn-secondary.scss" />